var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "prelative" },
    [
      _c("preloader", {
        staticClass: "preloader",
        attrs: { display: _vm.loading }
      }),
      _vm._v(" "),
      _vm.corporation == 0
        ? _c("div", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$l10n.__("Compte non synchronisé")) +
                ".\n        " +
                _vm._s(
                  _vm.$l10n.__("Veuillez ré-essayer dans quelques instants")
                ) +
                "...\n    "
            )
          ])
        : _c("div", [
            _vm.customer.deleted === true
              ? _c("div", [
                  _c("span", { staticClass: "label label-danger" }, [
                    _vm._v(_vm._s(_vm.$l10n.__("Compte Sellsy supprimé")))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.maintenance
              ? _c("div", [
                  _c("p", [
                    _vm._v("CORPID #" + _vm._s(_vm.customer.saasCorpId))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "label label-danger" }, [
                    _vm._v(_vm._s(_vm.$l10n.__("Maintenance en cours")))
                  ])
                ])
              : _c("div", [
                  _c(
                    "table",
                    {
                      staticClass:
                        "table no-shadow table-condensed table-info wordbreak table-layout-fixed table-noborder"
                    },
                    [
                      _c("tr", [
                        _c("th", [
                          _vm._v("CORPID #" + _vm._s(_vm.customer.saasCorpId))
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.customer.sendEthicAccountId
                        ? _c("tr", [
                            _c("th", [_vm._v(_vm._s("Marketing ID"))]),
                            _vm._v(" "),
                            _c("td", { attrs: { align: "right" } }, [
                              _vm._v(
                                _vm._s("#" + _vm.customer.sendEthicAccountId)
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("tr", [
                        _c("th", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$l10n.__("État du compte")) +
                              "\n                    "
                          )
                        ]),
                        _vm._v(" "),
                        _vm.customer.locked === false
                          ? _c("td", { attrs: { align: "right" } }, [
                              _c(
                                "span",
                                {
                                  class:
                                    "thirdlabel labelCorp-" +
                                    _vm.customer.levelReadable +
                                    "-bg semibold mr-0"
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.customer.levelReadable) +
                                      "\n                        "
                                  )
                                ]
                              )
                            ])
                          : _c("td", { attrs: { align: "right" } }, [
                              _c(
                                "span",
                                {
                                  class:
                                    "thirdlabel labelCorp-blocked-bg semibold mr-0"
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$l10n.__("bloqué")) +
                                      "\n                        "
                                  )
                                ]
                              )
                            ])
                      ]),
                      _vm._v(" "),
                      _vm.customer.locked === false &&
                      (_vm.customer.levelReadable === "trial" ||
                        _vm.customer.levelReadable === "basic")
                        ? _c("tr", [
                            _c("th", [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$l10n.__("Trial")) +
                                  "\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "pointer",
                                attrs: { align: "right" },
                                on: { click: _vm.editTrial }
                              },
                              [
                                _vm.customer.levelReadable === "trial"
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("saasDateFormatted")(
                                            _vm.customer.trialEndDate
                                          )
                                        )
                                      )
                                    ])
                                  : _c("span", [
                                      _vm._v(_vm._s(_vm.$l10n.__("Non")))
                                    ])
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.customer.locked === false &&
                      _vm.customer.levelReadable === "trial"
                        ? _c("tr", [
                            _c("th", [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$l10n.__("Imports illimités")) +
                                  "\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { attrs: { align: "right" } }, [
                              _vm.customerSettings.hasImportUnlimited
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "fright semibold spanLabel spanLabel-green",
                                      class: {
                                        pointer: _vm.canToggleImportLimited
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.toggleImportLimited(false)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.$l10n.__("Oui")) +
                                          "\n                        "
                                      )
                                    ]
                                  )
                                : _c(
                                    "span",
                                    {
                                      staticClass:
                                        "fright semibold spanLabel spanLabel-red",
                                      class: {
                                        pointer: _vm.canToggleImportLimited
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.toggleImportLimited(true)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.$l10n.__("Non")) +
                                          "\n                        "
                                      )
                                    ]
                                  )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("tr", [
                        _c("th", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$l10n.__("Plan")) +
                              "\n                    "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { align: "right" } }, [
                          null !== _vm.billingSettings.pricingPlanCode
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "spanLabel spanLabel-lightgrey semibold capitalize"
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm._f("capitalize")(
                                          _vm._f("lowerCase")(
                                            _vm.billingSettings.pricingPlanCode
                                          )
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              )
                            : _c("span", [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$l10n.__("N/C")) +
                                    "\n                        "
                                )
                              ])
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.customer.levelReadable === "gold"
                        ? _c("tr", [
                            _c("td", { attrs: { colspan: "2" } }, [
                              _c(
                                "table",
                                { staticClass: "table table-noborder" },
                                [
                                  _c("tr", [
                                    _c(
                                      "td",
                                      { staticClass: "py-1 px-0 wp-5" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "semibold" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$l10n.__(
                                                  "Date de début service"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("br"),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm._f("saasDateFormatted")(
                                                  _vm.billingSettings
                                                    .serviceStartDate
                                                )
                                              ) +
                                              "\n                                    "
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "py-1 px-0 wp-5 aright" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "semibold" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$l10n.__(
                                                  "Date de fin service"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("br"),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm._f("saasDateFormatted")(
                                                  _vm.billingSettings
                                                    .serviceEndDate
                                                )
                                              ) +
                                              "\n                                    "
                                          )
                                        ])
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [
                          _c("span", { staticClass: "semibold" }, [
                            _vm._v(_vm._s(_vm.$l10n.__("Tarifs appliqués")))
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "aright" },
                          [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content:
                                    "rev." +
                                    _vm.billingSettings.pricingVersionRevision,
                                  placement: "right"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    "v." +
                                      _vm._s(_vm.billingSettings.pricingVersion)
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm.billingSettings.pricingVersion === 4 &&
                            _vm.customer.levelReadable === "trial" &&
                            !_vm.billingSettings.stripeSubscriptionSchedule &&
                            !_vm.billingSettings.stripeSubscriptionId
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "spanLabel spanLabel-lightgrey semibold pointer",
                                    on: {
                                      click: function($event) {
                                        return _vm.switchPricingVersion(3)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                            => v.3 ?\n                        "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.billingSettings.pricingVersion !== 4 &&
                            _vm.customer.levelReadable === "trial" &&
                            !_vm.billingSettings.stripeSubscriptionSchedule &&
                            !_vm.billingSettings.stripeSubscriptionId
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "spanLabel spanLabel-lightgrey semibold pointer",
                                    on: {
                                      click: function($event) {
                                        return _vm.switchPricingVersion(4)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                            => v.4 ?\n                        "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isPricingVersion5Enabled &&
                            _vm.billingSettings.pricingVersion < 5 &&
                            _vm.billingSettings.billingProvider ===
                              "chargebee" &&
                            _vm.customer.levelReadable === "trial" &&
                            !_vm.billingSettings.stripeSubscriptionSchedule &&
                            !_vm.billingSettings.stripeSubscriptionId
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "spanLabel spanLabel-lightgrey semibold pointer",
                                    on: {
                                      click: function($event) {
                                        return _vm.switchPricingVersion(5)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                            => v.5 ?\n                        "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _vm.isChargebeeEnabled
                        ? _c("tr", [
                            _c("td", [
                              _c(
                                "span",
                                { staticClass: "typographies-heading-h4" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$l10n.__("Service de facturation")
                                    )
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "aright" }, [
                              !_vm.customer.deleted &&
                              ["trial", "basic"].includes(
                                _vm.customer.levelReadable
                              ) &&
                              !_vm.billingSettings.stripeSubscriptionSchedule &&
                              !(
                                _vm.billingSettings.billingProvider ===
                                  "chargebee" &&
                                _vm.billingSettings.pricingVersion > 4
                              )
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "spanLabel spanLabel-lightgrey typographies-paragraph-caps-small-semibold pointer",
                                      on: {
                                        click: function($event) {
                                          return _vm.switchBillingProvider(
                                            _vm.billingSettings
                                              .billingProvider === "stripe"
                                              ? "chargebee"
                                              : "stripe"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm._f("capitalize")(
                                              _vm.billingSettings
                                                .billingProvider
                                            )
                                          ) +
                                          "\n                        "
                                      )
                                    ]
                                  )
                                : _c("span", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm._f("capitalize")(
                                            _vm.billingSettings.billingProvider
                                          )
                                        ) +
                                        "\n                        "
                                    )
                                  ])
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("td", { staticClass: "aright" }, [
                          _vm.billingSettings.selfService
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "fright semibold spanLabel spanLabel-green",
                                  class: { pointer: _vm.canToggleSelfService },
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleSelfService(false)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$l10n.__("Oui")) +
                                      "\n                        "
                                  )
                                ]
                              )
                            : _c(
                                "span",
                                {
                                  staticClass:
                                    "fright semibold spanLabel spanLabel-red",
                                  class: { pointer: _vm.canToggleSelfService },
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleSelfService(true)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$l10n.__("Non")) +
                                      "\n                        "
                                  )
                                ]
                              )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [
                          _c("span", { staticClass: "semibold" }, [
                            _vm._v(_vm._s(_vm.$l10n.__("Facturation SAAS")))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "aright" }, [
                          _vm.billingSettings.saasBillingEnabled
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "fright semibold spanLabel spanLabel-green",
                                  class: { pointer: _vm.canToggleSaasBilling },
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleSaasBilling(false)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$l10n.__("Oui")) +
                                      "\n                        "
                                  )
                                ]
                              )
                            : _c(
                                "span",
                                {
                                  staticClass:
                                    "fright semibold spanLabel spanLabel-red",
                                  class: { pointer: _vm.canToggleSaasBilling },
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleSaasBilling(true)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$l10n.__("Non")) +
                                      "\n                        "
                                  )
                                ]
                              )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.billingSettings.vatIdentificationNumber
                        ? _c("tr", [
                            _c("td", [
                              _c("span", { staticClass: "semibold" }, [
                                _vm._v(_vm._s(_vm.$l10n.__("TVA intra")))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "aright" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("upperCase")(
                                      _vm.billingSettings
                                        .vatIdentificationNumber
                                    )
                                  )
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [
                          _c("span", { staticClass: "semibold" }, [
                            _vm._v(_vm._s(_vm.$l10n.__("Nb staffs autorisé")))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "aright" }, [
                          _c(
                            "span",
                            {
                              class: {
                                pointer: _vm.canEditAvailableStaffNumber
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toggleEditAvailableStaffNumber()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.availableStaffNumber))]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [
                          _c("span", { staticClass: "semibold" }, [
                            _vm._v(_vm._s(_vm.$l10n.__("MRR")))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "aright" }, [
                          _vm.billingSettings.mrr
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatAmount(
                                      _vm.billingSettings.mrr / 100,
                                      true
                                    )
                                  )
                                )
                              ])
                            : _c("span", [_vm._v(_vm._s(_vm.$l10n.__("N/C")))])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [
                          _c("span", { staticClass: "semibold" }, [
                            _vm._v(_vm._s(_vm.$l10n.__("ARR")))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "aright" }, [
                          _vm.billingSettings.arr
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatAmount(
                                      _vm.billingSettings.arr / 100,
                                      true
                                    )
                                  )
                                )
                              ])
                            : _c("span", [_vm._v(_vm._s(_vm.$l10n.__("N/C")))])
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.editAvailableStaffNumber
                        ? _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "aright",
                                attrs: { colspan: "2" }
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.availableStaffNumberTmp,
                                      expression: "availableStaffNumberTmp"
                                    }
                                  ],
                                  staticClass: "h-4 mr-2",
                                  attrs: {
                                    type: "number",
                                    min: "1",
                                    max: "100"
                                  },
                                  domProps: {
                                    value: _vm.availableStaffNumberTmp
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.availableStaffNumberTmp =
                                        $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("CompassButton", {
                                  staticClass: "pointer",
                                  attrs: {
                                    label: _vm._f("capitalize")(
                                      _vm.$t.__("common.actions.cancel")
                                    ),
                                    type: "secondary",
                                    size: "small"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleEditAvailableStaffNumber()
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("CompassButton", {
                                  attrs: {
                                    label: _vm._f("capitalize")(
                                      _vm.$t.__("common.actions.validate")
                                    ),
                                    type: "primary",
                                    size: "small",
                                    disabled:
                                      _vm.availableStaffNumber ===
                                      _vm.availableStaffNumberTmp
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.recordAvailableStaffNumber()
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.thirdPayerId
                        ? _c("tr", [
                            _c("td", [
                              _c("span", { staticClass: "semibold" }, [
                                _vm._v(_vm._s(_vm.$l10n.__("Tiers payeur")))
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "aright" },
                              [
                                _c("CompassLink", {
                                  attrs: {
                                    label: _vm.thirdPayerName,
                                    link: _vm.thirdPayerUrl
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(1),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "aright" },
                          [
                            _vm.canEditUtm
                              ? _c("CompassButton", {
                                  attrs: {
                                    label: _vm._f("capitalize")(
                                      _vm.$t.__(
                                        "sellsyadmin.CorporationData_v3.edit"
                                      )
                                    ),
                                    type: "tertiary"
                                  },
                                  on: { click: _vm.editUtm }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _vm.utm && _vm.utm.source
                        ? _c("tr", [
                            _c("td", { attrs: { colspan: "2" } }, [
                              _c(
                                "table",
                                {
                                  staticClass:
                                    "table no-shadow table-condensed table-info wordbreak table-layout-fixed table-noborder"
                                },
                                [
                                  _c("tr", [
                                    _c("th", { staticClass: "p-0 pl-3" }, [
                                      _vm._v("source")
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "p-0 aright" }, [
                                      _vm._v(_vm._s(_vm.utm.source))
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c("th", { staticClass: "p-0 pl-3" }, [
                                      _vm._v("medium")
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "p-0 aright" }, [
                                      _vm._v(_vm._s(_vm.utm.medium))
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c("th", { staticClass: "p-0 pl-3" }, [
                                      _vm._v("campaign")
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "p-0 aright" }, [
                                      _vm._v(_vm._s(_vm.utm.campaign))
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _vm.utm.source === "affiliation"
                                    ? _c("tr", [
                                        _c("th", { staticClass: "p-0 pl-3" }, [
                                          _vm._v("parrain")
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "p-0 aright" },
                                          [_vm._v(_vm._s(_vm.utm.parrainname))]
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              )
                            ])
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "overview-actions mt-2 bt-1 pt-1" },
                    [
                      _vm.canUnlinkCorp
                        ? _c(
                            "li",
                            { staticClass: "mt-2" },
                            [
                              _c("CompassButton", {
                                attrs: {
                                  label: _vm.$t.__(
                                    "sellsyadmin.CorporationData_v3.unlink_account"
                                  ),
                                  type: "secondary"
                                },
                                on: { click: _vm.unlinkCorporation }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.canLinkThirdPayer
                        ? _c(
                            "li",
                            { staticClass: "mt-2" },
                            [
                              _c("CompassButton", {
                                attrs: {
                                  label: _vm.$t.__(
                                    "sellsyadmin.CorporationData_v3.link_third_payer"
                                  ),
                                  type: "secondary"
                                },
                                on: { click: _vm.linkThirdPayer }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.canUnlinkThirdPayer
                        ? _c(
                            "li",
                            { staticClass: "mt-2" },
                            [
                              _c("CompassButton", {
                                attrs: {
                                  label: _vm.$t.__(
                                    "sellsyadmin.CorporationData_v3.unlink_third_payer"
                                  ),
                                  type: "secondary"
                                },
                                on: { click: _vm.unlinkThirdPayer }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.canSynchronizeContactFromCorporation
                        ? _c(
                            "li",
                            { staticClass: "mt-2" },
                            [
                              _c("CompassButton", {
                                attrs: {
                                  label: _vm.$t.__(
                                    "sellsyadmin.CorporationData_v3.synchronize_contact"
                                  ),
                                  type: "secondary"
                                },
                                on: { click: _vm.synchronizeContacts }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.canBlockAccount
                        ? _c(
                            "li",
                            { staticClass: "mt-2" },
                            [
                              _c("CompassButton", {
                                attrs: {
                                  label: _vm.$t.__(
                                    "sellsyadmin.CorporationData_v3.block_account"
                                  ),
                                  type: "secondary"
                                },
                                on: { click: _vm.lockCustomer }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.canUnblockAccount
                        ? _c(
                            "li",
                            { staticClass: "mt-2" },
                            [
                              _c("CompassButton", {
                                attrs: {
                                  label: _vm.$t.__(
                                    "sellsyadmin.CorporationData_v3.unblock_account"
                                  ),
                                  type: "secondary"
                                },
                                on: { click: _vm.unlockCustomer }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.customer.levelReadable === "gold" &&
                      _vm.canChurnCustomerPermission &&
                      !_vm.isChargebeeProvider
                        ? [
                            _c(
                              "li",
                              { staticClass: "mt-2" },
                              [
                                _c("CompassButton", {
                                  attrs: {
                                    label: _vm.$t.__(
                                      "sellsyadmin.CorporationData_v3.churn"
                                    ),
                                    type: "secondary",
                                    disabled: _vm.churnActionLoading
                                  },
                                  on: { click: _vm.doChurnAction }
                                })
                              ],
                              1
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.customer.deleted &&
                      _vm.billingSettings.salesCartEnabled &&
                      !_vm.isChargebeeProvider
                        ? [
                            _c(
                              "li",
                              { staticClass: "mt-2" },
                              [
                                _c("CompassButton", {
                                  attrs: {
                                    label: _vm.$t.__(
                                      "sellsyadmin.CorporationData_v3.create_cart"
                                    ),
                                    type: "secondary"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.hrefButton(_vm.newCartUrl)
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.customer.billingSettings.pricingVersion < 4 &&
                            _vm.customer.levelReadable === "basic" &&
                            !_vm.isChargebeeProvider
                              ? [
                                  _c(
                                    "li",
                                    { staticClass: "mt-2" },
                                    [
                                      _c("CompassButton", {
                                        attrs: {
                                          label: _vm.$t.__(
                                            "sellsyadmin.CorporationData_v3.create_v4_cart"
                                          ),
                                          type: "secondary"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.hrefButton(
                                              _vm.newCartV4Url
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isGold && !_vm.isChargebeeProvider
                              ? [
                                  _vm.customer.billingSettings
                                    .pricingVersion === 3
                                    ? _c(
                                        "li",
                                        { staticClass: "mt-2" },
                                        [
                                          _c("CompassButton", {
                                            attrs: {
                                              label: _vm.$t.__(
                                                "sellsyadmin.CorporationData_v3.create_v3_renew_cart"
                                              ),
                                              type: "secondary"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.hrefButton(
                                                  _vm.renewV3Url
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "mt-2" },
                                    [
                                      _c("CompassButton", {
                                        attrs: {
                                          label: _vm.$t.__(
                                            "sellsyadmin.CorporationData_v3.create_v4_renew_cart"
                                          ),
                                          type: "secondary"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.hrefButton(
                                              _vm.renewV4Url
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              : _vm._e()
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.customer.deleted &&
                      _vm.billingSettings.chargebeeCustomerId
                        ? [
                            _c(
                              "li",
                              { staticClass: "mt-2" },
                              [
                                _c("CompassButton", {
                                  attrs: {
                                    label: _vm.$t.__(
                                      "sellsyadmin.CorporationData_v3.access_bubble"
                                    ),
                                    type: "secondary"
                                  },
                                  on: { click: _vm.goToBubble }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "mt-2" },
                              [
                                _c("CompassButton", {
                                  attrs: {
                                    label: _vm.$t.__(
                                      "sellsyadmin.CorporationData_v3.view_invoices"
                                    ),
                                    type: "secondary"
                                  },
                                  on: {
                                    click: _vm.openChargebeeInvoicingDialog
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.customer.levelReadable === "trial"
                        ? [
                            _c(
                              "li",
                              { staticClass: "mt-2" },
                              [
                                _c("CompassButton", {
                                  attrs: {
                                    label: _vm.trialBannerButtonLabel,
                                    type: "secondary"
                                  },
                                  on: { click: _vm.toggleTrialBanner }
                                })
                              ],
                              1
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ])
          ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("span", { staticClass: "semibold" }, [_vm._v("Self Service")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("span", { staticClass: "semibold" }, [_vm._v("UTM")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }